export default "__VITE_ASSET__BN_l_mtR__"